import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import NumberFormat from 'react-number-format';
import Select from 'react-select';
import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import cadastrarTrecho from '../../actions/trecho/cadastrarTrecho'
import buscarTrechos from '../../actions/trecho/buscarTrechos';
import {buscarConfiguracoesBilhete} from '../../actions/configuracao-bilhete/configuracaoBilheteActions';
import {
  renderFieldCheck,
  renderFieldKM,
  renderFieldMonetarioLabelEncima,
  renderFieldNumber,
  renderFieldSelect,
  renderFieldText
} from '../../util/inputs';
import {estados} from '../../util/constantsUtil';
import {showAlertMsg, showSuccessMsg} from '../../util/messagesUtil';
import salvarPontosEmbarque from '../../actions/pontoEmbarque/salvarPontosEmbarque';
import { renderField } from '../../util/arraysUtil'
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import MapaTrecho from './MapaTrecho';

export const validate = (values) => {
    const errors = {};

    if (!values.cidadeDestino) {
        errors.cidadeDestino = 'Campo obrigatório'
    }
    if (!values.preco) {
        errors.preco = 'Campo obrigatório'
    }
    if (!values.duracao) {
        errors.duracao = 'Campo obrigatório'
    }
    if (!values.quilometragem) {
        errors.quilometragem = 'Campo obrigatório'
    }
    const pontoValor = values.pontoEmbarque;
    if (!pontoValor || (typeof pontoValor === 'object' && !pontoValor.value)) {
        errors.pontoEmbarque = 'Campo obrigatório'
    }

    return errors
};

const renderFieldDuracao = ({
                                input,
                                label,
                                css,
                                max,
                                readOnly,
                                meta: {touched, error}
                            }) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <NumberFormat {...input} format="##:##"
                          className={css}
                          maxLength={max}
                          style={{borderColor: touched && error ? 'red' : ''}}
                          readOnly={readOnly}
            />
            {touched
            && (error && <span style={{color: 'red'}}>{error}</span>)}
        </div>
    </div>
);

class CriarPontoEmbarqueInline extends React.Component {
    constructor(props) {
        super(props);
        this.state = { texto: '', exibir: false };
        this.salvar = this.salvar.bind(this);
    }

    salvar() {
        const nome = this.state.texto.trim();
        if (!nome) return;
        this.props.onCriar(nome, () => this.setState({ texto: '', exibir: false }));
    }

    render() {
        if (!this.state.exibir) {
            return (
                <button type="button"
                        style={{ fontSize: '12px', color: '#FF6A00', background: 'none', border: 'none', padding: '2px 0', cursor: 'pointer' }}
                        onClick={() => this.setState({ exibir: true })}>
                    + Criar novo ponto de embarque
                </button>
            );
        }
        return (
            <div style={{ display: 'flex', gap: '6px', marginTop: '4px' }}>
                <input
                    type="text"
                    autoFocus
                    className="form-control form-control-sm"
                    placeholder="Nome do novo ponto..."
                    value={this.state.texto}
                    onChange={e => this.setState({ texto: e.target.value })}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.salvar(); } }}
                />
                <button type="button" className="vx-btn-secondary"
                        style={{ fontSize: '12px', whiteSpace: 'nowrap' }}
                        onClick={this.salvar}>
                    Salvar
                </button>
                <button type="button" className="vx-btn-icon"
                        onClick={() => this.setState({ exibir: false, texto: '' })}>
                    <i className="material-icons" style={{ fontSize: '16px' }}>close</i>
                </button>
            </div>
        );
    }
}

export class ModalCadastrarTrecho extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.exibirSelectPontoEmbarque = this.exibirSelectPontoEmbarque.bind(this);
        this.handleCriarPonto = this.handleCriarPonto.bind(this);
        this.state = {
            tiposQualificacao: [],
            cidadeDestino: [],
            estadoDestinoSelecionado: '',
            rotaSelecionada: '',
            currentLocation: {lat: -15.93721552072724, lng: -47.79491945592459},
            bounds: null,
            pontosEmbarqueTrecho: []
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarConfiguracoesBilhete(this.props.empresaSelecionada.id);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id &&
            prevProps.empresaSelecionada && this.props.empresaSelecionada.id !== prevProps.empresaSelecionada.id) {
            this.props.buscarConfiguracoesBilhete(this.props.empresaSelecionada.id);
        }
        const cidadeAtual = this.props.cidadeDestino && this.props.cidadeDestino.value;
        const cidadeAnterior = prevProps.cidadeDestino && prevProps.cidadeDestino.value;
        if (cidadeAtual && cidadeAtual !== cidadeAnterior) {
            this.carregarPontosEmbarque(cidadeAtual);
        } else if (this.props.idTrecho && this.props.idTrecho !== prevProps.idTrecho && this.state.pontosEmbarqueTrecho.length > 0) {
            this.tentarAutoSelecionarPonto(this.state.pontosEmbarqueTrecho);
        }
    }

    carregarPontosEmbarque(cidadeId) {
        if (!cidadeId || !this.props.empresaSelecionada || !this.props.empresaSelecionada.id) return;
        const url = `${URL}/ponto-embarque/empresa/${this.props.empresaSelecionada.id}/cidade/${cidadeId}`;
        axios.get(url, SLOW_REQUEST_CONFIG).then(response => {
            if (response && response.data) {
                this.setState({ pontosEmbarqueTrecho: response.data });
                this.tentarAutoSelecionarPonto(response.data);
            }
        });
    }

    tentarAutoSelecionarPonto(pontos) {
        const val = this.props.pontoEmbarqueFormValue;
        if (!val || typeof val !== 'string') return;
        const match = pontos.find(p => p.nome === val);
        if (match) {
            this.props.changeFieldValue('formularioCadastroTrecho', 'pontoEmbarque', {
                value: match.id,
                label: match.nome
            });
        }
    }

    handleCriarPonto(nome, onSucesso) {
        if (!nome || !this.props.cidadeDestino || !this.props.cidadeDestino.value) return;
        const comando = {
            cidadeId: this.props.cidadeDestino.value,
            empresaId: this.props.empresaSelecionada.id,
            pontosNovos: [nome]
        };
        this.props.salvarPontosEmbarque(comando).then(response => {
            if (response && response.data && response.data.length > 0) {
                const novoPonto = response.data[0];
                this.setState(prev => ({
                    pontosEmbarqueTrecho: [...prev.pontosEmbarqueTrecho, novoPonto]
                }));
                this.props.changeFieldValue('formularioCadastroTrecho', 'pontoEmbarque', {
                    value: novoPonto.id,
                    label: novoPonto.nome
                });
                showSuccessMsg('Ponto de embarque criado e selecionado com sucesso');
                if (onSucesso) onSucesso();
            }
        }).catch(() => showAlertMsg('Erro ao criar ponto de embarque.'));
    }

    exibirSelectPontoEmbarque(event) {
        const opcoes = this.state.pontosEmbarqueTrecho.map(p => ({ value: p.id, label: p.nome }));
        return (
            <div>
                <label className='mt-2'>Ponto de embarque:</label>
                <Select
                    {...event.input}
                    noOptionsMessage={() => 'Nenhum ponto cadastrado para esta cidade'}
                    placeholder='Selecione o ponto de embarque...'
                    options={opcoes}
                    value={event.input.value && event.input.value.value ? event.input.value : null}
                    onChange={value => event.input.onChange(value)}
                    onBlur={() => event.input.onBlur()}
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
                {event.meta.touched && event.meta.error && (
                    <span style={{ color: 'red' }}>{event.meta.error}</span>
                )}
            </div>
        );
    }

    buscarTrechos() {
        this.props.buscarTrechos(this.props.empresaSelecionada.id, this.props.rotaSelecionada.value);
    }

    submit(values) {
        this.props.cadastrarTrecho(this.montarParametroTrecho(values))
            .then(() => {
                showSuccessMsg(`Trecho ${this.props.idTrecho ? 'atualizado' : 'cadastrado'} com sucesso`);
                this.buscarTrechos()
            })
    }

    montarParametroTrecho(values) {
        const taxaEmbarque = !values.taxaEmbarque || this.possuiConfiguracaoBilheteSelecionados() ? '0,00' : values.taxaEmbarque.replace('R$', '');
        const pedagio = !values.pedagio ? '0,00' : values.pedagio.replace('R$', '');

        let cidadeOrigemAlternativa = null;
        let cidadeDestinoAlternativa = null;
        if (values.habilitadoBpeCidadeAlternativo) {
            cidadeOrigemAlternativa =  this.props.origem ? this.props.origem.nomeComUf : null;
            cidadeDestinoAlternativa = this.props.destino ? this.props.destino.nomeComUf : null;
        } else {
            cidadeOrigemAlternativa = values.cidadeOrigemAlternativa;
            cidadeDestinoAlternativa = values.cidadeDestinoAlternativa;
        }

        return {
            id: this.props.idTrecho,
            cidadeDestinoId: values.cidadeDestino.value,
            preco: values.preco,
            duracao: values.duracao,
            quilometragem: values.quilometragem,
            empresaId: this.props.empresaSelecionada.id,
            rotaId: this.props.rotaSelecionada.value,
            ordem: values.ordem,
            taxaEmbarque,
            pedagio,
            pontoEmbarque: values.pontoEmbarque && typeof values.pontoEmbarque === 'object'
                ? values.pontoEmbarque.label
                : values.pontoEmbarque,
            pontoEmbarqueId: values.pontoEmbarque && typeof values.pontoEmbarque === 'object'
                ? values.pontoEmbarque.value
                : null,
            habilitadoBpeCidadeAlternativo: values.habilitadoBpeCidadeAlternativo,
            origemAlternativaId: this.props.origem ? this.props.origem.id : null,
            destinoAlternativaId: this.props.destino ? this.props.destino.id : null,
            cidadeOrigemAlternativa: cidadeOrigemAlternativa,
            cidadeDestinoAlternativa: cidadeDestinoAlternativa,
            conexaoId: values.conexao ? values.conexao.value : null,
            habilitadoTrechoAlternativoLimeteEstadual: values.habilitadoTrechoAlternativoLimeteEstadual,            
            regra: this.props.configuracoesBilheteSelecionados.map(it => it.id),
            latitude: values.latitude,
            longitude: values.longitude,
            plataformaEmbarque: values.plataformaEmbarque,
            habilitadoVenderSemConexao: values.habilitadoVenderSemConexao,
            habilitadoInformarAntt: values.habilitadoInformarAntt !== false,
            nomeInstalacao: values.nomeInstalacao,
            codigoInstalacao: values.codigoInstalacao,
            conexoesUsadas: this.props.conexaoUsadas.map(it => {
                return {
                    rotaId: this.props.rotaSelecionada.value,
                    conexaoOrigemId: it.id,
                    trechoDestinoId: this.props.idTrecho,
                    trechoOrigemId: it.trechoOrigemId
                }
            }),
            cidadesOrigensVendaDireta: this.props.cidadesOrigemVendaDireta.map(it => {
                return {
                    rotaId: this.props.rotaSelecionada.value,
                    trechoDestinoId: this.props.idTrecho,
                    trechoOrigemId: it.trechoOrigemId,
                    cidadeOrigemId: it.id
                }
            })
        };
    }

    limparFormulario() {
        this.props.reset('formularioCadastroTrecho');
        this.props.limparConfiguracoesBilheteSelecionados();
        this.props.limparConexoesUsadas();
        this.props.limparCidadeOrigemVendaDireta();
        this.limparCamposBuscaCidadeAlternativo();
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroTrecho',
            'cidadeDestino', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'preco', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'pedagio', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'duracao', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'rota', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'pontoEmbarque', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'plataformaEmbarque', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'habilitadoTrechoAlternativoLimeteEstadual', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'nomeInstalacao', '');
        this.props.changeFieldValue('formularioCadastroTrecho',
            'codigoInstalacao', '');

        this.setState({
            estadoDestinoSelecionado: '',
            rotaSelecionada: ''
        });
    }

    handleEstadoDestino = (estado) => {
        const url = `${URL}/public/cidades/${estado.value}`;
        this.props.changeFieldValue('formularioCadastroTrecho',
            'cidadeDestino', '');
        axios.get(url, SLOW_REQUEST_CONFIG)
            .then((response) => {
                if (response != null) {
                    this.setState({
                        cidadeDestino: response.data,
                        estadoDestinoSelecionado: estado
                    })
                }
            })
    };

    exibirComboCidadeDestino(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione uma cidade...'
                    options={this.state.cidadeDestino.map(elemento => ({
                        label: `${elemento.nome}-${elemento.uf}`,
                        value: elemento.id
                    }))}
                    onChange={value => event.input.onChange(value)}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboEstadoDestino(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione o estado destino...'
                    options={estados.map(elemento => ({
                        label: `${elemento.nome}-${elemento.uf}`,
                        value: elemento.uf
                    }))}
                    onChange={value => {
                        this.handleEstadoDestino(value);
                        event.input.onChange(value)
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    handleExibirCamposBPE() {
        if (this.props.habilitadoTrechoAlternativoLimeteEstadual) {
            this.limparInformacoesBPE()
        }
        this.props.changeFieldValue('formIncluirPassageiro', 'habilitadoTrechoAlternativoLimeteEstadual', !this.props.habilitadoTrechoAlternativoLimeteEstadual);
    }

    alterarLatitudeLongitude(latitude, longitude) {
        this.props.changeFieldValue('formularioCadastroTrecho',
            'latitude', latitude)
        this.props.changeFieldValue('formularioCadastroTrecho',
            'longitude', longitude)
        this.setState({
            latitude: latitude,
            longitude: longitude
        })

    }
        
    renderMapa() {
        return <div className='form-row col-12 col-md-12' style={{height: '500px'}}>
                <MapaTrecho isOpen={this.props.isModalOpen}
                    latitude={this.props.latitude}
                    longitude={this.props.longitude}
                    alterarLatitudeLongitude={this.alterarLatitudeLongitude.bind(this)} />
        </div>
    }
    
    exibeCidadesOrigemVendaDireta() {
        return (
            <div style={{ border: '1px solid #eee', borderRadius: '4px', overflow: 'hidden', marginTop: '4px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', padding: '8px 12px', fontWeight: '600', fontSize: '12px', background: '#f8f8f8', borderBottom: '2px solid #FF6A00', color: '#0F0F0F' }}>
                    <div>Descrição</div>
                    <div></div>
                </div>
                {this.props.cidadesOrigemVendaDireta && this.props.cidadesOrigemVendaDireta.length === 0 ? (
                    <div style={{ padding: '12px', textAlign: 'center', color: '#888', fontSize: '13px' }}>
                        Nenhum item adicionado.
                    </div>
                ) : this.props.cidadesOrigemVendaDireta && this.props.cidadesOrigemVendaDireta.map(it => (
                    <div key={it.id} style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: '13px', alignItems: 'center' }}>
                        <div>{it.descricao}</div>
                        <div>
                            <button type="button" className="vx-btn-danger" style={{ padding: '2px 10px', fontSize: '12px' }}
                                    onClick={() => this.removerCidadeOrigemVendaDireta(it.id)}>
                                Remover
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    adicionarCidadeOrigemVendaDireta(e) {
        e.preventDefault();
        if (this.props.cidadesOrigemVendaDireta.filter(it => it.id === e.value).length === 0) {            
            const trechoOrigem = this.props.trechos.find(it => it.cidadeDestino.id === e.value)
            if (trechoOrigem) {                
                const cidadesOrigemVendaDiretaSelecionado = Object.assign([], this.props.cidadesOrigemVendaDireta);                
                cidadesOrigemVendaDiretaSelecionado.push({ id: trechoOrigem.cidadeDestino.id, descricao: `${trechoOrigem.cidadeDestino.nome}-${trechoOrigem.cidadeDestino.uf}`, trechoOrigemId: trechoOrigem.id });
                this.props.preencherCidadeOrigemVendaDireta(cidadesOrigemVendaDiretaSelecionado);

            }            
        }
    }

    removerCidadeOrigemVendaDireta(id) {
        const cidadesOrigemVendaDireta = Object.assign([], this.props.cidadesOrigemVendaDireta);        
        this.props.preencherCidadeOrigemVendaDireta(cidadesOrigemVendaDireta.filter(it => !(it.id === id)));
    }

    retornarConexoesAtivas() {
        if (this.props.trechos.length) {            
            const conexaoAtiva = this.props.trechos.map(trecho => {
                if (trecho.conexao) {                    
                    return {
                        id: trecho.conexao.id,
                        trechoOrigemId: trecho.id,
                        descricao: `${trecho.conexao.prefixo ? trecho.conexao.prefixo : 'Prefixo não informado'}: ${trecho.conexao.cidadeOrigem.nome}-${trecho.conexao.cidadeOrigem.uf} -> ${trecho.conexao.cidadeDestino.nome}-${trecho.conexao.cidadeDestino.uf}`,
                        nome: trecho.conexao.id
                    }
                }
            }).filter(it => it != undefined)
            
            return conexaoAtiva;
        } 

        return [];
    }

    exibeConexaoUsadas() {
        return (
            <div style={{ border: '1px solid #eee', borderRadius: '4px', overflow: 'hidden', marginTop: '4px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', padding: '8px 12px', fontWeight: '600', fontSize: '12px', background: '#f8f8f8', borderBottom: '2px solid #FF6A00', color: '#0F0F0F' }}>
                    <div>Descrição</div>
                    <div></div>
                </div>
                {this.props.conexaoUsadas && this.props.conexaoUsadas.length === 0 ? (
                    <div style={{ padding: '12px', textAlign: 'center', color: '#888', fontSize: '13px' }}>
                        Nenhum item adicionado.
                    </div>
                ) : this.props.conexaoUsadas && this.props.conexaoUsadas.map(it => (
                    <div key={it.id} style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: '13px', alignItems: 'center' }}>
                        <div>{it.descricao}</div>
                        <div>
                            <button type="button" className="vx-btn-danger" style={{ padding: '2px 10px', fontSize: '12px' }}
                                    onClick={() => this.removerConexaoUsadaSelecionado(it.id)}>
                                Remover
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    adicionarConexaoUsada(e) {
        e.preventDefault();
        if (this.props.conexaoUsadas.filter(it => it.id === e.value).length === 0) {
            const conexoesAtivas = this.retornarConexoesAtivas();            
            const conexaoUsada = conexoesAtivas.find(it => it.id === e.value)            
            if (conexaoUsada) {
                const conexaoUsadaSelecionda = Object.assign([], this.props.conexaoUsadas);
                conexaoUsadaSelecionda.push(conexaoUsada)
                this.props.preencherConexoesUsadas(conexaoUsadaSelecionda);

            }
        }
    }

    removerConexaoUsadaSelecionado(id) {
        const conexaoUsadas = Object.assign([], this.props.conexaoUsadas);        
        this.props.preencherConexoesUsadas(conexaoUsadas.filter(it => !(it.id === id)));
    }

    exibeConfiguracoesBilhete() {        
        return (
            <div style={{ border: '1px solid #eee', borderRadius: '4px', overflow: 'hidden', marginTop: '4px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', padding: '8px 12px', fontWeight: '600', fontSize: '12px', background: '#f8f8f8', borderBottom: '2px solid #FF6A00', color: '#0F0F0F' }}>
                    <div>Descrição</div>
                    <div></div>
                </div>
                {this.props.configuracoesBilheteSelecionados && this.props.configuracoesBilheteSelecionados.length === 0 ? (
                    <div style={{ padding: '12px', textAlign: 'center', color: '#888', fontSize: '13px' }}>
                        Nenhum item adicionado.
                    </div>
                ) : this.props.configuracoesBilheteSelecionados && this.props.configuracoesBilheteSelecionados.map(it => (
                    <div key={it.id} style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: '13px', alignItems: 'center' }}>
                        <div>{it.descricao} {`R$ ${it.valor}`}</div>
                        <div>
                            <button type="button" className="vx-btn-danger" style={{ padding: '2px 10px', fontSize: '12px' }}
                                    onClick={() => this.removerItemSelecionado(it.id)}>
                                Remover
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    removerItemSelecionado(id) {
        const configuracoesBilheteSelecionados = Object.assign([], this.props.configuracoesBilheteSelecionados);        
        this.props.preencherConfiguracoesBilheteSelecinados(configuracoesBilheteSelecionados.filter(it => !(it.id === id)));
    }

    validarSePossuiMesmaRegra(e) {
        if (this.props.configuracoesBilheteSelecionados.length > 0) {                
            const conf =  this.props.configuracoesBilhete.filter(it => it.id == e.value)[0]
            
            const configs = this.props.configuracoesBilhete.map(it => {
                if (this.props.configuracoesBilheteSelecionados.map(it2 => it2.id).includes(it.id)) {
                    return it
                }
                return null
            }).filter(it => it != null)
                            
            if (configs.filter(it => it).every(it => it.regra.chave != conf.regra.chave)) {                
                return true;
            }
        }

        return false;
    }

    adicionarConfiguracaoBilhete(e) {
        e.preventDefault();
        if (this.props.configuracoesBilheteSelecionados.filter(it => it.id === e.value).length === 0) {
            if (this.validarSePossuiMesmaRegra(e)) {
                showAlertMsg('Não é possivel aplicar mais de um tipo de regra');
                return;
            }

            const configuracoesBilheteSelecionados = Object.assign([], this.props.configuracoesBilheteSelecionados);
            configuracoesBilheteSelecionados.push({
                id: e.value,
                descricao: e.label
            })            
            this.props.preencherConfiguracoesBilheteSelecinados(configuracoesBilheteSelecionados);
        }
    }

    rotaSelecionadaPossuiConexao() {
        return this.props.rotaSelecionada && this.props.rotaSelecionada.conexoes && this.props.rotaSelecionada.conexoes.length;
    }

    possuiConfiguracaoBilheteSelecionados() {        
        return this.props.configuracoesBilheteSelecionados.length > 0 && this.props.configuracoesBilheteSelecionados.map(it => it.descricao).filter(it => it != 'Regra Curitiba - Curitiba').length > 0
    }

    limpaCidadesSelecionadas(sentido) {
        if (sentido === 'pesquisaOrigem') {
            this.selecionarOrigem(null)
        }
        if (sentido === 'pesquisaDestino') {
            this.selecionarDestino(null)
        }
    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem);
    }

    selecionarDestino(destino) {
        this.props.selecionarDestino(destino);
    }

    mostrarCamposBuscaCidadesAlternativos() {
        return (<>
            <div className="input-group mb-3 mt-3">
                <div className="col-12 col-sm-12 col-md-6 mb-6">
                    <label htmlFor='pesquisaDestino'>Cidade Destino alternativa:</label>
                    <SelecaoCidadeAutocomplete limparViagens={this.limpaCidadesSelecionadas.bind(this)}
                        name='pesquisaDestino'                                                
                        selecionarCidade={this.selecionarDestino.bind(this)}
                        value={this.props.destino}
                    />
                </div>
                <div className="col-12 col-sm-12 col-md-6 mb-6">
                    <label htmlFor='pesquisaOrigem'>Cidade Origem alternativa:</label>
                    <SelecaoCidadeAutocomplete limparViagens={this.limpaCidadesSelecionadas.bind(this)}
                        name='pesquisaOrigem'                        
                        selecionarCidade={this.selecionarOrigem.bind(this)}
                        value={this.props.origem}
                    />
                </div>
                
                <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12" />
                <Field name="destino" type="hidden" component={renderField} css="form-control col-md-12" />
            </div>
        
        </>)
    }

    limparCamposBuscaCidadeAlternativoEvento(event) {
        if (!event.target.checked) {
            this.limparCamposBuscaCidadeAlternativo();
        }
    }

    limparCamposBuscaCidadeAlternativo() {
        this.limpaCidadesSelecionadas('pesquisaDestino');
        this.limpaCidadesSelecionadas('pesquisaOrigem');
        this.props.changeFieldValue('formularioCadastroTrecho', 'pesquisaDestino', '');
        this.props.changeFieldValue('formularioCadastroTrecho', 'destino', '');
        this.props.changeFieldValue('formularioCadastroTrecho', 'pesquisaOrigem', '');
        this.props.changeFieldValue('formularioCadastroTrecho', 'origem', '');
    }
    
    render() {
        const {
            handleSubmit
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarTrecho' role='dialog'
                 aria-labelledby='modalCadastrarTrecho' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-icon">
                                <i className="material-icons">compare_arrows</i>
                            </div>
                            <div>
                                <h5 className="vx-modal-title">{this.props.idTrecho ? 'Editar Trecho' : 'Novo Trecho'}</h5>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row mb-2">
                                    <div className="col-12">
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Cidade de origem</label>
                                                <div>
                                                    <strong>{this.props.idTrecho ? this.props.cidadeOrigem : this.props.ultimoTrecho}</strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className='col-md-9 col-sm-9 col-md-6'>
                                                <Field name="pontoEmbarque"
                                                       component={this.exibirSelectPontoEmbarque}/>
                                                <CriarPontoEmbarqueInline onCriar={this.handleCriarPonto}/>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className='col-md-9 col-sm-9 col-md-4'>
                                                <Field name="plataformaEmbarque" component={renderFieldText}
                                                       label="Plataforma de embarque:"
                                                       css="form-control" readOnly={false}/>
                                            </div>
                                        </div>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Estado de destino</label>
                                                <Field name='estadoDestino'
                                                       component={this.exibirComboEstadoDestino.bind(this)}/>
                                            </div>
                                            <div className="col-12 col-sm-9 col-md-6">
                                                <label>Cidade de destino</label>
                                                <Field name='cidadeDestino'
                                                       component={this.exibirComboCidadeDestino.bind(this)}/>
                                            </div>
                                            {this.props.rotaSelecionada && this.props.rotaSelecionada.opcoesTrechoAlternativo
                                                ? <div className='ml-1 mt-2'>
                                                    <div className="form-row mt-2">
                                                        <div className="col-12 col-sm-12 col-md-12">
                                                            <Field name='habilitadoBpeCidadeAlternativo'
                                                                   onChange={(event) => this.limparCamposBuscaCidadeAlternativoEvento(event)}
                                                                   type="checkbox" component={renderFieldCheck}
                                                                   label="Habilitar Bpe Cidade Alternativo"
                                                                   css="form-check-input" readOnly={false}/>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        {this.props.habilitadoBpeCidadeAlternativo ?<>
                                                            {this.mostrarCamposBuscaCidadesAlternativos()}
                                                        </> : <><div className="col-12 col-sm-9 col-md-6">
                                                                <Field name="cidadeDestinoAlternativa"
                                                                    component={renderFieldText}
                                                                    label="Cidade Destino alternativa:"
                                                                    readOnly={false}/>
                                                            </div>
                                                            <div className="col-12 col-sm-9 col-md-6">
                                                                <Field name="cidadeOrigemAlternativa"
                                                                    component={renderFieldText}
                                                                    label="Cidade Origem alternativa:"
                                                                    readOnly={false}/>
                                                            </div>                                                        
                                                        </>}
                                                    </div>
                                                    <div className="form-row mt-2">
                                                        <div className="col-12 col-sm-9 col-md-9">
                                                            <Field name='habilitadoTrechoAlternativoLimeteEstadual'
                                                                   type="checkbox" component={renderFieldCheck}
                                                                   label="Habilitar apenas no mesmo estado"
                                                                   css="form-check-input" readOnly={false}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ''
                                            }
                                        </div>
                                        <div className='form-row mt-2'>
                                            <div className='form col-12 col-sm-9 col-md-6'>
                                                <Field name="nomeInstalacao" component={renderFieldText} label="Nome Instalação:"
                                                       css="form-control" readOnly={false}/>
                                            </div>
                                            <div className='form col-12 col-sm-9 col-md-6'>
                                                <Field name="codigoInstalacao" component={renderFieldText} label="Código Instalação:"
                                                       css="form-control" readOnly={false}/>
                                            </div>
                                        </div>
                                        <div className='form-row mt-2'>
                                            <div className='col-12'>
                                                <label>Informar ANTT</label>
                                                <div className='form-group form-check'>
                                                    <input type="checkbox" name='habilitadoInformarAntt' id='habilitadoInformarAntt'
                                                           className='form-check-input'
                                                           checked={this.props.habilitadoInformarAntt !== false}
                                                           onChange={(event) => this.props.changeFieldValue('formularioCadastroTrecho', 'habilitadoInformarAntt', event.target.checked)}/>
                                                    <label className='form-check-label' htmlFor='habilitadoInformarAntt'>Sim</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.rotaSelecionadaPossuiConexao() ? <div className="form-row mt-6">
                                    <div className='col-sm-12 col-md-10'>
                                        <Field name='habilitadoVenderSemConexao'
                                               type="checkbox" component={renderFieldCheck}
                                               label="Vender Sem Conexão"
                                               css="form-check-input" readOnly={false}/>
                                    </div>
                                </div> : ''}

                                {this.rotaSelecionadaPossuiConexao() ? <>
                                <div className='form-row mb-4'>
                                    <div className='col-sm-10 col-md-10'>
                                                <Field name='conexaoAtiva'
                                                    options={this.retornarConexoesAtivas()
                                                        .filter(ca => !this.props.conexaoUsadas.map(it => it.id).includes(ca.id))}
                                                    component={renderFieldSelect}
                                                    isClearable
                                                    label='Conexões Usadas'
                                                    placeholder='Selecione...'
                                                    onChange={(e) => this.adicionarConexaoUsada(e)}
                                                />
                                            </div>
                                </div>
                                <div className='form-row'>
                                       <div className='col-sm-10 col-md-10'>
                                        {this.exibeConexaoUsadas()}
                                       </div>
                                    </div>
                                </> : ''}

                                {this.rotaSelecionadaPossuiConexao() ? <>
                                <div className='form-row mb-4'>
                                    <div className='col-sm-10 col-md-10'>
                                                <Field name='cidadeOrigemVendaDireta'
                                                    options={this.props.trechos.filter(it => this.props.trechoSelecionado != null && it.ordem < this.props.trechoSelecionado.ordem)
                                                        .filter(cd => !this.props.cidadesOrigemVendaDireta.map(it => it.id).includes(cd.cidadeDestino.id)).map(it => {
                                                        return {                                                            
                                                            descricao: `${it.cidadeDestino.nome}-${it.cidadeDestino.uf}`,
                                                            nome: it.cidadeDestino.id
                                                        }
                                                    })}
                                                    component={renderFieldSelect}
                                                    isClearable
                                                    label='Cidades Origem Venda Sem Conexão'
                                                    placeholder='Selecione...'
                                                    onChange={(e) => this.adicionarCidadeOrigemVendaDireta(e)}
                                                />
                                            </div>
                                </div>
                                <div className='form-row'>
                                       <div className='col-sm-10 col-md-10'>
                                        {this.exibeCidadesOrigemVendaDireta()}
                                       </div>
                                    </div>
                                </> : ''}

                                <div style={{ borderTop: '1px solid #eee', margin: '12px 0 8px' }}></div>
                                <div className='form-row mb-2'>
                                    <div className='col-12'>
                                        <span style={{ fontWeight: '600', fontSize: '13px', color: '#FF6A00', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <i className="material-icons" style={{ fontSize: '16px' }}>receipt</i>
                                            Regra de Bilhete / Taxa de Embarque
                                        </span>
                                    </div>
                                </div>
                                <div className='form-row mb-2'>
                                    <div className='col-sm-10 col-md-10'>
                                        <Field name='regraBilhete'
                                               options={(this.props.configuracoesBilhete || [])
                                                .filter(cbs => cbs && !this.props.configuracoesBilheteSelecionados.map(it => it.id).includes(cbs.id)).map(elemento => {
                                                    const valor = elemento.confsBilheteKm && elemento.confsBilheteKm.length ? `R$ ${elemento.confsBilheteKm[0].valor}` : ''
                                                    return {
                                                        descricao: `${elemento.regra.valor} - ${elemento.descricao}, ${valor}`,
                                                        nome: elemento.id
                                                    }
                                                })}
                                               component={renderFieldSelect}
                                               isClearable
                                               label='Selecionar Regra'
                                               placeholder='Selecione...'
                                               onChange={(e) => this.adicionarConfiguracaoBilhete(e)}
                                        />
                                    </div>
                                </div>
                                <div className='form-row mb-3'>
                                    <div className='col-sm-10 col-md-10'>
                                        {this.exibeConfiguracoesBilhete()}
                                    </div>
                                </div>
                                <div style={{ borderTop: '1px solid #eee', margin: '4px 0 12px' }}></div>
                                <div className="form-row">
                                    <div className='col-sm-9 col-md-2'>
                                        <Field name="duracao" component={renderFieldDuracao} label="Duração:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                    <div className='col-sm-9 col-md-2'>
                                        <Field name="quilometragem" component={renderFieldKM} label="Quilometragem:"
                                               css="form-control" readOnly={false}/>
                                    </div>
                                    <div className='col-sm-9 col-md-3'>
                                        <Field name='taxaEmbarque' component={renderFieldMonetarioLabelEncima}
                                               className="form-control" label="Taxa de embarque:" readOnly={this.possuiConfiguracaoBilheteSelecionados()}/>
                                    </div>
                                    <div className='col-sm-9 col-md-3'>
                                        <Field name='pedagio' component={renderFieldMonetarioLabelEncima}
                                               className="form-control" label="Pedágio:"/>
                                    </div>
                                    <div className='form-row mt-2'>
                                        <div className='form col-12 col-sm-9 col-md-6'>
                                            <Field name="latitude" component={renderFieldNumber} label="Latitude:"
                                                   css="form-control" readOnly={true}/>
                                        </div>
                                        <div className='form col-12 col-sm-9 col-md-6'>
                                            <Field name="longitude" component={renderFieldNumber} label="Longitude:"
                                                   css="form-control" readOnly={true}/>
                                        </div>
                                    </div>
                                    {this.renderMapa()}
                                    {this.rotaSelecionadaPossuiConexao() ?
                                        <div className='col-sm-9 col-md-7'>
                                            <Field name='conexao'
                                                   options={this.props.rotaSelecionada.conexoes.map(elemento => ({
                                                       descricao: `${elemento.prefixo ? elemento.prefixo : 'Prefixo não informado'}: ${elemento.cidadeOrigem.nome}-${elemento.cidadeOrigem.uf} -> ${elemento.cidadeDestino.nome}-${elemento.cidadeDestino.uf} `,
                                                       nome: elemento.id
                                                   }))}
                                                   component={renderFieldSelect}
                                                   isClearable
                                                   label='Conexão:'
                                                   placeholder='Selecione...'
                                            />
                                        </div> : ''}
                                </div>

                                <div className="form-group area-codigo">
                                    <Field name="codigoTrecho" type="hidden" component={renderFieldText}
                                           css="form-control col-md-12"/>
                                </div>
                                <div className="vx-modal-footer">
                                    <button type="submit" className="vx-btn-primary">Salvar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
        
    }
}


export function mapStateToProps(state) {
    return {
        idTrecho: formValueSelector('formularioCadastroTrecho')(state, 'idTrecho'),
        latitudeSelecionada: formValueSelector('formularioCadastroTrecho')(state, 'latitudeSelecionada'),
        longitudeSelecionada: formValueSelector('formularioCadastroTrecho')(state, 'longitudeSelecionada'),
        cidadeDestino: formValueSelector('formularioCadastroTrecho')(state, 'cidadeDestino'),
        estetadoDestino: formValueSelector('formularioCadastroTrecho')(state, 'estadoDestino'),
        cidadeAlternativa: formValueSelector('formularioCadastroTrecho')(state, 'cidadeAlternativa'),
        cidadeOrigem: formValueSelector('formularioCadastroTrecho')(state, 'cidadeOrigem'),
        duracao: formValueSelector('formularioCadastroTrecho')(state, 'duracao'),
        rota: formValueSelector('formularioCadastroTrecho')(state, 'rota'),
        conexao: formValueSelector('formularioCadastroTrecho')(state, 'conexao'),
        habilitadoTrechoAlternativoLimeteEstadual: formValueSelector('formularioCadastroTrecho')(state, 'habilitadoTrechoAlternativoLimeteEstadual'),
        empresaSelecionada: state.empresaSelecionada,
        rotaSelecionada: state.rotaSelecionada,
        configuracoesBilhete: state.configuracaoBilhete.configuracoesBilheteTrecho,
        latitude: formValueSelector('formularioCadastroTrecho')(state, 'latitude') ? formValueSelector('formularioCadastroTrecho')(state, 'latitude') : -15.93721552072724,
        longitude: formValueSelector('formularioCadastroTrecho')(state, 'longitude') ? formValueSelector('formularioCadastroTrecho')(state, 'longitude') : -47.79491945592459,
        plataformaEmbarque: formValueSelector('formularioCadastroTrecho')(state, 'plataformaEmbarque'),
        habilitadoVenderSemConexao: formValueSelector('formularioCadastroTrecho')(state, 'habilitadoVenderSemConexao'),
        habilitadoInformarAntt: formValueSelector('formularioCadastroTrecho')(state, 'habilitadoInformarAntt'),
        nomeInstalacao: formValueSelector('formularioCadastroTrecho')(state, 'nomeInstalacao') ? formValueSelector('formularioCadastroTrecho')(state, 'nomeInstalacao') : '',
        codigoInstalacao: formValueSelector('formularioCadastroTrecho')(state, 'codigoInstalacao') ? formValueSelector('formularioCadastroTrecho')(state, 'codigoInstalacao') : '',
        habilitadoBpeCidadeAlternativo: formValueSelector('formularioCadastroTrecho')(state, 'habilitadoBpeCidadeAlternativo'),
        pontoEmbarqueFormValue: formValueSelector('formularioCadastroTrecho')(state, 'pontoEmbarque'),
        origem: state.origem,
        destino: state.destino

    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        buscarConfiguracoesBilhete,
        cadastrarTrecho,
        buscarTrechos,
        selecionarOrigem,
        selecionarDestino,
        salvarPontosEmbarque
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroTrecho',
    validate
})(ModalCadastrarTrecho));
